"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingSuccess = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../organisms");
const TrackingSuccess_style_1 = require("./TrackingSuccess.style");
const react_native_1 = require("react-native");
const atome_1 = require("../../atome");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const UtilityFunctions_1 = require("../../../helper/UtilityFunctions");
function TrackingSuccess({ navigation, route }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const navigateToLogin = () => {
        (0, UtilityFunctions_1.signOff)({ nav: () => navigation.navigate('Login') });
    };
    const navigateAfterSubmission = () => {
        if (route.params && route.params.redirectPage) {
            navigation.navigate(route.params.redirectPage);
            return;
        }
        navigation.navigate("Dashboard");
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white', minHeight: '100%' } },
        react_1.default.createElement(react_native_1.ScrollView, null,
            !auth.isAuthenticated && react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
            auth.isAuthenticated && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: [TrackingSuccess_style_1.styles.container] },
                react_1.default.createElement(react_native_1.View, { style: [
                        Breakpoints_1.isPhablet || Breakpoints_1.isDesktop ? TrackingSuccess_style_1.styles.row : TrackingSuccess_style_1.styles.alignCenter,
                        react_native_1.Platform.OS !== 'web' ? { marginTop: 40 } : null,
                        { marginBottom: 40 },
                    ] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(atome_1.Icon, { icon: 'healthTracking', size: 100 })),
                    react_1.default.createElement(react_native_1.View, { style: [
                            Breakpoints_1.isPhablet || Breakpoints_1.isDesktop
                                ? TrackingSuccess_style_1.styles.marginLeft20
                                : TrackingSuccess_style_1.styles.alignCenter,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [TrackingSuccess_style_1.styles.heading3] }, "THERAPIE MONITORING"),
                        react_1.default.createElement(atome_1.Text, { style: [TrackingSuccess_style_1.styles.heading2] }, "Vielen Dank f\u00FCr Ihre Angaben!"),
                        react_1.default.createElement(react_native_1.View, { style: [TrackingSuccess_style_1.styles.row] },
                            !auth.isAuthenticated && (react_1.default.createElement(react_native_1.Pressable, { style: TrackingSuccess_style_1.styles.button, onPress: () => navigateToLogin() },
                                react_1.default.createElement(atome_1.Text, { style: [TrackingSuccess_style_1.styles.buttonText] }, "ZUM LOGIN"))),
                            auth.isAuthenticated && (react_1.default.createElement(react_native_1.Pressable, { style: TrackingSuccess_style_1.styles.button, onPress: navigateAfterSubmission },
                                react_1.default.createElement(atome_1.Text, { style: [TrackingSuccess_style_1.styles.buttonText] }, route.params
                                    ? route.params.redirectPage === "OnlineAppointment"
                                        ? "Videosprechstunde buchen"
                                        : route.params.redirectPage === "FollowPrescription"
                                            ? "Folgerezept beantragen"
                                            : ""
                                    : "Zum Dashboard"))))))))));
}
exports.TrackingSuccess = TrackingSuccess;
